// import * as $ from 'jquery';

import { Component, OnInit } from "@angular/core";
import { AuthService } from "src/app/core/service/auth.service";
import { AppService } from "src/app/shared/service/app.service";

@Component({
  selector: "app-side-bar",
  templateUrl: "./side-bar.component.html",
  styleUrls: ["./side-bar.component.scss"],
  
})
export class SideBarComponent implements OnInit {
  public userRole: string;
  public user: any;

  constructor(private appService: AppService, private auth: AuthService) {}

  ngOnInit() {
    this.user = this.auth.userValue;
    if (this.auth.userValue) {
      this.userRole = this.user.role;
    }
    //     $(".sidebar-dropdown > a").click(function() {
    //   $(".sidebar-submenu").slideUp(200);
    //   if (
    //     $(this)
    //       .parent()
    //       .hasClass("active")
    //   ) {
    //     $(".sidebar-dropdown").removeClass("active");
    //     $(this)
    //       .parent()
    //       .removeClass("active");
    //   } else {
    //     $(".sidebar-dropdown").removeClass("active");
    //     $(this)
    //       .next(".sidebar-submenu")
    //       .slideDown(200);
    //     $(this)
    //       .parent()
    //       .addClass("active");
    //   }
    // });

    // $("#close-sidebar").click(function() {
    //   $(".page-wrapper").removeClass("toggled");
    // });
    // $("#show-sidebar").click(function() {
    //   $(".page-wrapper").addClass("toggled");
    // });
  }

  isCollapsed = false;

  toggleSidebarPin() {
    this.isCollapsed = !this.isCollapsed;
    this.appService.toggleSidebarPin();
  }
  toggleSidebar() {
    this.appService.toggleSidebar();
  }
}
